// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .nav-link {
  color: var(--bs-text-dark) !important;
  font-weight: 400 !important;
}

.nav-link.active {
  color: var(--bs-text-primary) !important;
  font-weight: 600 !important;
} */

/* Dropdown toggle cursor */
[ngbDropdownToggle] {
  cursor: pointer !important;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImR5bmFtaWMtYWN0aW9uLWJ1dHRvbnMuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7R0FRRzs7QUFFSCwyQkFBMkI7QUFDM0I7RUFDRSwwQkFBMEI7QUFDNUIiLCJmaWxlIjoiZHluYW1pYy1hY3Rpb24tYnV0dG9ucy5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLyogLm5hdi1saW5rIHtcbiAgY29sb3I6IHZhcigtLWJzLXRleHQtZGFyaykgIWltcG9ydGFudDtcbiAgZm9udC13ZWlnaHQ6IDQwMCAhaW1wb3J0YW50O1xufVxuXG4ubmF2LWxpbmsuYWN0aXZlIHtcbiAgY29sb3I6IHZhcigtLWJzLXRleHQtcHJpbWFyeSkgIWltcG9ydGFudDtcbiAgZm9udC13ZWlnaHQ6IDYwMCAhaW1wb3J0YW50O1xufSAqL1xuXG4vKiBEcm9wZG93biB0b2dnbGUgY3Vyc29yICovXG5bbmdiRHJvcGRvd25Ub2dnbGVdIHtcbiAgY3Vyc29yOiBwb2ludGVyICFpbXBvcnRhbnQ7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/partials/dynamic-preview-buttons/dynamic-action-buttons.component.css"],"names":[],"mappings":"AAAA;;;;;;;;GAQG;;AAEH,2BAA2B;AAC3B;EACE,0BAA0B;AAC5B;;AAEA,4sBAA4sB","sourcesContent":["/* .nav-link {\n  color: var(--bs-text-dark) !important;\n  font-weight: 400 !important;\n}\n\n.nav-link.active {\n  color: var(--bs-text-primary) !important;\n  font-weight: 600 !important;\n} */\n\n/* Dropdown toggle cursor */\n[ngbDropdownToggle] {\n  cursor: pointer !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
